import React, { useEffect, useRef, useState } from "react";
import { FiZoomIn, FiZoomOut } from "react-icons/fi";
import { LuPencilLine } from "react-icons/lu";
import { BiCommentAdd } from "react-icons/bi";
import { IoIosArrowDown } from "react-icons/io";
import { GrRedo, GrUndo } from "react-icons/gr";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
import Tools from "./Tools";
import throttle from "lodash.throttle";
import { jwtDecode } from "jwt-decode";
import { getAllEvaluatorTasks } from "components/Helper/Evaluator/EvalRoute";
import socket from "../../services/socket/socket";
import {
  addComment,
  updateComment,
  deleteComment,
  addAnnotation,
  updateAnnotation,
  deleteAnnotation,
  addMark,
  updateMark,
  deleteMark,
} from "../../store/annotationSlice";
import {
  setCurrentIcon,
  setIsDraggingIcon,
  setRerender,
  setIcons,
  setCurrentMarkDetails,
} from "store/evaluatorSlice";
import { Rnd } from "react-rnd";
import {
  getNormalizedCoords,
  getScaledCoords,
} from "../../utils/annotationUtils";
import { postMarkById } from "components/Helper/Evaluator/EvalRoute";
import { createIcon } from "components/Helper/Evaluator/EvalRoute";
import { getIconsByImageId } from "components/Helper/Evaluator/EvalRoute";
import { deleteIconByImageId } from "components/Helper/Evaluator/EvalRoute";
import html2canvas from "html2canvas";
import { submitImageById } from "components/Helper/Evaluator/EvalRoute";
import useAnnotationSync from "../../hook/useAnnotationSync";

const getIconsByRole = (role) => {
  const baseIcons = {
    blank: ["/blank1.png", "/blank2.png", "/blank3.png"],
    check: ["/check1.png", "/check2.png", "/check3.png"],
    circle: ["/circle1.png", "/circle2.png", "/circle3.png"],
    cross: ["/cross1.png", "/cross2.png", "/cross3.png"],
    line: ["/line1.png", "/line2.png", "/line3.png"],
    not_attempt: [
      "/not_attempt1.png",
      "/not_attempt2.png",
      "/not_attempt3.png",
    ],
    question: ["/question1.png", "/question2.png", "/question3.png"],
    slantline: ["/slantline1.png", "/slantline2.png", "/slantline3.png"],
    eye: ["/eye1.png", "/eye2.png", "/eye3.png"],
    rough: ["/rough1.png", "/rough2.png", "/rough3.png"],
  };

  const filtered = {};

  Object.keys(baseIcons).forEach((key) => {
    if (role === "evaluator") {
      filtered[key] = [baseIcons[key][0]]; // only 1
    } else if (role === "headevaluator") {
      filtered[key] = baseIcons[key].slice(1, 2); // only 1,2
    } else {
      filtered[key] = baseIcons[key].slice(2); // all 1,2,3
    }
  });

  return filtered;
};

const preprocessImage = (canvas) => {
  const context = canvas.getContext("2d");

  // Convert the image to grayscale (preprocessing step)
  const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;

  for (let i = 0; i < data.length; i += 4) {
    const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
    data[i] = avg; // Red
    data[i + 1] = avg; // Green
    data[i + 2] = avg; // Blue
  }

  context.putImageData(imageData, 0, 0);
  return canvas.toDataURL("image/png");
};
const ImageContainer = (props) => {
  const [scale, setScale] = useState(1); // Initial zoom level
  const [icons, setIcons] = useState([]); // State for placed icons
  // const [isDraggingIcon, setIsDraggingIcon] = useState(false); // Track if an icon is being dragged
  // const [currentIcon, setCurrentIcon] = useState(null); // Store the currently selected icon
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 }); // Track mouse position for preview
  const [iconModal, setIconModal] = useState(false);
  const [rotation, setRotation] = useState(0);
  const [draggedIconIndex, setDraggedIconIndex] = useState(null);
  const [isDrawing, setIsDrawing] = useState(false); // Drawing mode toggle
  const [drawing, setDrawing] = useState([]); // Store strokes
  const evaluatorState = useSelector((state) => state.evaluator);
  const [scalePercent, setScalePercent] = useState(100);
  const [isZoomMenuOpen, setIsZoomMenuOpen] = useState(false);
  const [canvasSize, setCanvasSize] = useState({ width: 0, height: 0 });
  // const [canvasStates, setCanvasStates] = useState({});
  const [currentImage, setCurrentImage] = useState(null);
  const [drawingsByPage, setDrawingsByPage] = useState({});
  const [startDrawing, setStartDrawing] = useState(false);
  const [showLens, setShowLens] = useState(false);
  const [lensPos, setLensPos] = useState({ x: 0, y: 0 });
  const [lensImagePos, setLensImagePos] = useState({ x: 0, y: 0 });
  const [selectedIcon, setSelectedIcon] = useState(null);
  const [mouseBasePos, setMouseBasePos] = useState({ x: 0, y: 0 });
  const [mouseUp, setMouseUp] = useState(false);
  // const [markPlaced, setMarkPlaced] = useState(false);
  const [selectedColor, setSelectedColor] = useState("red");
  const [isCursorInside, setIsCursorInside] = useState(false);
  const [toolMode, setToolMode] = useState("draw"); // "draw" | "erase"
  const [opacity, setOpacity] = useState(1); // 0 → 1
  const [currentStrokeWidth, setCurrentStrokeWidth] = useState(10);
  const [comments, setcomments] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const containerRef = useRef(null);
  const currentIndex = evaluatorState.currentIndex;
  const currentQuestionNo = evaluatorState.currentQuestion;
  const baseImageUrl = evaluatorState.baseImageUrl;
  const currentIcon = evaluatorState.currentIcon;
  const isDraggingIcon = evaluatorState.isDraggingIcon;
  const currentMarkDetails = evaluatorState.currentMarkDetails;
  const currentAnswerImageId = evaluatorState.currentAnswerPdfImageId;
  const currentQuestionDefinitionId =
    evaluatorState?.currentQuestionDefinitionId;
  const currentAnswerPdfId = evaluatorState.currentAnswerPdfId;
  const currentParentId = evaluatorState.currentSubQuestionParentId;
  const [lensImage, setLensImage] = useState(null);
  const canvasRef = useRef(null);
  const iconRefs = useRef([]);
  const dispatch = useDispatch();
  const commentStore = useSelector((state) => state.annotation.commentStore);
  const iconsStore = useSelector((state) => state.annotation.annotationStore);
  const marksStore = useSelector((state) => state.annotation.marksStore);
  // const icons = evaluatorState.icons;
  // console.log(currentMarkDetails);
  // console.log(props.id)
  const imgRef = useRef(null);
  const [lensSize, setLensSize] = useState(150);
  const lensZoom = 2.5;

  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const imageRef = useRef(null);
  const imageWrapperRef = useRef(null);
  const [imageDimensions, setImageDimensions] = useState({
    width: 0,
    height: 0,
  });

  // console.log(currentAnswerPdfId);
  useAnnotationSync(
    props.id,
    currentIndex,
    currentAnswerPdfId,
    props.taskdetails?.userId
  );
  // const [annotations, setAnnotations] = useState([]);
  const debounceTimers = useRef({});

  const token = localStorage.getItem("token");

  let role = "evaluator"; // fallback

  try {
    const decoded = jwtDecode(token);
    role = decoded?.role?.toLowerCase();
  } catch (e) {
    console.error("Token decode failed");
  }

  useEffect(() => {
    const img = imageRef.current;
    if (img && img.complete) {
      setImageDimensions({ width: img.width, height: img.height });
    } else if (img) {
      img.onload = () =>
        setImageDimensions({ width: img.width, height: img.height });
    }
  }, [currentIndex]);

  // console.log(currentIndex)

  // useEffect(()=>{
  //   const canvas = canvasRef.current;
  //   const ctx = canvas.getContext("2d");

  //   // Clear the canvas
  //   ctx.clearRect(0, 0, canvas.width, canvas.height);

  //   // Load the saved state for the current index
  //   if (canvasStates[canvasStates.length-1]) {
  //     const img = new Image();
  //     img.src = canvasStates[currentIndex];
  //     img.onload = () => {
  //       ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  //     };
  //   }
  // },[isDrawing])
  console.log(props);

  const imageSrc = `${process.env.REACT_APP_API_URL}\\${baseImageUrl}\\image_${currentIndex}.png`;
  // const imageSrc = `${process.env.REACT_APP_API_URL}\\${baseImageUrl}\\question_page${}_area1.png`;

  // console.log(commentStore);

  useEffect(() => {
    let lastRightClickTime = 0;

    // const handleMouseDown = (e) => {
    //   // 🖊 LEFT DOUBLE CLICK → TOGGLE PEN
    //   if (e.button === 0 && e.detail === 2) {
    //     setIsDrawing((prev) => {
    //       const next = !prev;
    //       setToolMode("draw");
    //       toast.info(next ? "Pen Tool Enabled" : "Pen Tool Disabled");
    //       return next;
    //     });
    //   }

    //   // 🖱 RIGHT DOUBLE CLICK → TOGGLE BLANK ICON
    //   if (e.button === 2) {
    //     e.preventDefault();

    //     const now = Date.now();
    //     if (now - lastRightClickTime < 300) {
    //       const nextIcon = currentIcon === "/blank.png" ? null : "/blank.png";
    //       dispatch(setCurrentIcon(nextIcon));

    //       toast.info(
    //         nextIcon ? "Blank Icon Selected" : "Blank Icon Deselected"
    //       );
    //     }

    //     lastRightClickTime = now;
    //   }
    // };

    const handleWheelZoom = (e) => {
      e.preventDefault();

      setScale((prev) => {
        const zoomAmount = 0.1;
        let next = e.deltaY < 0 ? prev + zoomAmount : prev - zoomAmount;
        return Math.min(Math.max(next, 0.5), 3);
      });
    };

    // window.addEventListener("mousedown", handleMouseDown);
    // window.addEventListener("wheel", handleWheelZoom, { passive: false });

    return () => {
      // window.removeEventListener("mousedown", handleMouseDown);
      // window.removeEventListener("wheel", handleWheelZoom);
    };
  }, [currentIcon]);

  useEffect(() => {
    const img = imgRef.current;
    if (!img) return;

    // If image already loaded from cache
    if (img.complete) {
      setDimensions({
        width: img.naturalWidth,
        height: img.naturalHeight,
      });
    } else {
      // Wait for image to load
      img.onload = () => {
        setDimensions({
          width: img.naturalWidth,
          height: img.naturalHeight,
        });
      };
    }

    // Cleanup (avoid memory leaks)
    return () => {
      if (img) img.onload = null;
    };
  }, [imageSrc]); // re-run if the image changes

  // console.log(dimensions);

  useEffect(() => {
    if (showLens) {
      getStageImage().then(setLensImage);
    }
  }, [showLens, drawing, iconsStore, commentStore]);

  const getStageImage = async () => {
    if (!containerRef.current) return null;
    const canvas = await html2canvas(containerRef.current, { useCORS: true });
    return canvas.toDataURL("image/png");
  };

  // const handleAddComments = (e) => {
  //   const sheetRect = e.currentTarget.getBoundingClientRect();
  //   const newAnnotation = {
  //     id: Date.now(),
  //     page: currentIndex,
  //     x: e.clientX - sheetRect.left,
  //     y: e.clientY - sheetRect.top,
  //     width: 150,
  //     height: 60,
  //     text: "",
  //     taskId: props.id,
  //     answerPdfId: currentAnswerPdfId,
  //     userId: props.taskdetails?.userId,
  //   };
  //   // const updated = [newAnnotation];
  //   // setAnnotations(updated);
  //   dispatch(addComment(newAnnotation));
  // };

  const handleAddComments = (e) => {
    const { x, y } = getNormalizedCoords(
      e.clientX,
      e.clientY,
      canvasRef,
      scale
    );

    const newAnnotation = {
      id: Date.now(),
      page: currentIndex,
      x,
      y,
      width: 150,
      height: 60,
      text: "",
      taskId: props.id,
      answerPdfId: currentAnswerPdfId,
      userId: props.taskdetails?.userId,
    };

    dispatch(addComment(newAnnotation));
  };

  useEffect(() => {
    const blankExists = iconsStore.some(
      (icon) => icon.page === currentIndex && icon.iconUrl === "/blank.png"
    );

    props.setblankCheck(blankExists);
  }, [iconsStore, currentIndex]);
  // console.log(commentStore);

  const handleDragStop = (id, x, y) => {
    const commentToUpdate = commentStore.find((a) => a.id === id);
    if (!commentToUpdate) return; // Safety check

    const updatedComment = {
      ...commentToUpdate,
      x,
      y,
      synced: false, // mark as unsynced
    };

    dispatch(updateComment(updatedComment));
  };
  const handleCommentChange = (id, e) => {
    const text = e.target.value;

    // Update immediately in the store (instant UI update)
    const updatedComment = {
      ...commentStore.find((c) => c.id === id),
      text,
      synced: false,
    };
    dispatch(updateComment(updatedComment));

    // Only debounce if the key pressed is Backspace
    if (e.nativeEvent.inputType === "deleteContentBackward") {
      if (debounceTimers.current[id]) clearTimeout(debounceTimers.current[id]);

      debounceTimers.current[id] = setTimeout(() => {
        const commentToUpdate = commentStore.find((c) => c.id === id);
        if (!commentToUpdate) return;
        const updated = { ...commentToUpdate, text, synced: false };
        dispatch(updateComment(updated));
      }, 500);
    }
  }; // 500ms after user stops typing };

  // console.log(comments);

  useEffect(() => {
    const fetchAllIcons = async () => {
      const icons = await getIconsByImageId(
        currentAnswerImageId,
        currentQuestionDefinitionId
      );

      if (Array.isArray(icons)) setIcons(icons);
    };
    if (currentQuestionDefinitionId && currentAnswerImageId) {
      fetchAllIcons();
    }
  }, [
    currentQuestionDefinitionId,
    currentAnswerImageId,
    evaluatorState.rerender,
  ]);
  // Handle clicks outside of selected icon

  // Handle double-click outside of the specific image container
  useEffect(() => {
    const handleOutsideDoubleClick = (event) => {
      if (selectedIcon !== null) {
        const selectedIconRef = iconRefs.current[selectedIcon];
        if (selectedIconRef && !selectedIconRef.contains(event.target)) {
          setSelectedIcon(null); // Deselect icon if clicked outside
        }
      }
    };

    document.addEventListener("mousedown", handleOutsideDoubleClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideDoubleClick); // Cleanup on unmount
    };
  }, [selectedIcon]);

  // Load the canvas state when the image changes
  // useEffect(() => {
  //   const loadCanvasState = () => {
  //     const canvas = canvasRef.current;
  //     const ctx = canvas.getContext("2d");

  //     // Clear the canvas
  //     ctx.clearRect(0, 0, canvas.width, canvas.height);

  //     // Load the saved state for the current index
  //     if (canvasStates[currentIndex]) {
  //       const img = new Image();
  //       img.src = canvasStates[currentIndex];
  //       img.onload = () => {
  //         ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  //       };
  //     }
  //   };

  //   // Save the current canvas state before changing the index
  //   if (currentImage !== null) {
  //     // saveCanvasState();
  //   }

  //   setCurrentImage(currentIndex); // Track the currently displayed image
  //   // loadCanvasState();
  // }, [currentIndex]);

  // Function to update canvas size when image is scaled
  useEffect(() => {
    if (canvasRef.current) {
      const canvas = canvasRef.current;
      const imageElement = document.querySelector('img[alt="Viewer"]');
      const imageWidth = imageElement ? imageElement.width : 0;
      const imageHeight = imageElement ? imageElement.height : 0;

      // Scale the canvas size based on the scale factor
      const scaledWidth = imageWidth;
      const scaledHeight = imageHeight;

      setCanvasSize({ width: scaledWidth, height: scaledHeight });

      // Update canvas width and height
      canvas.width = scaledWidth;
      canvas.height = scaledHeight;
    }
  }, [isDrawing]); // Run effect every time scale changes
  // Draw on the canvas
  // useEffect(() => {
  //   if (startDrawing) {
  //     const canvas = canvasRef.current;
  //     const context = canvas.getContext("2d");

  //     // Clear the canvas for redraw
  //     context.clearRect(0, 0, canvas.width, canvas.height);

  //     context.lineJoin = "round"; // Smooth line joins

  //     let prevX = null;
  //     let prevY = null;

  //     // Iterate through the drawing array
  //     drawing.forEach(({ x, y, mode, strokeWidth, color }) => {
  //       if (mode === "start") {
  //         // Update previous coordinates for the start of a new stroke
  //         prevX = x;
  //         prevY = y;
  //       }
  //       if (mode === "draw") {
  //         context.beginPath();
  //         context.lineWidth = strokeWidth || currentStrokeWidth; // Use strokeWidth or default to currentStrokeWidth
  //         context.strokeStyle = color || selectedColor; // Use color or default to selectedColor

  //         context.moveTo(prevX, prevY); // Start from the previous point
  //         context.lineTo(x, y); // Draw to the current point
  //         context.stroke(); // Render the line
  //         context.closePath();

  //         // Update previous coordinates
  //         prevX = x;
  //         prevY = y;
  //       }
  //     });
  //   }
  // }, [drawing, scale, startDrawing, currentStrokeWidth, selectedColor]);

  useEffect(() => {
    if (!props.aiResult?.results) return;

    Object.values(props.aiResult.results).forEach((item) => {
      dispatch(
        addMark({
          id: crypto.randomUUID(),
          page: item.page,
          marks: item.marks_awarded,
          maxMarks: item.max_marks,

          x: 100,
          y: 100,

          answerPdfId: currentAnswerPdfId,
        })
      );
    });
  }, [props.aiResult]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.lineJoin = "round";
    ctx.lineCap = "round";

    const points = drawingsByPage[currentIndex] || [];
    if (points.length === 0) return;

    let currentStroke = [];

    const drawStroke = (stroke) => {
      if (stroke.length < 2) return;

      ctx.beginPath();

      for (let i = 1; i < stroke.length; i++) {
        const prev = stroke[i - 1];
        const curr = stroke[i];

        const midX = (prev.x + curr.x) / 2;
        const midY = (prev.y + curr.y) / 2;

        ctx.lineWidth = curr.strokeWidth || currentStrokeWidth;

        if (curr.tool === "erase") {
          ctx.globalCompositeOperation = "destination-out";
          ctx.globalAlpha = 1;
        } else {
          ctx.globalCompositeOperation = "source-over";
          ctx.globalAlpha = opacity;
          ctx.strokeStyle = curr.color || selectedColor;
        }

        ctx.moveTo(prev.x, prev.y);
        ctx.quadraticCurveTo(prev.x, prev.y, midX, midY);
      }

      ctx.stroke();
      ctx.closePath();
    };

    points.forEach((pt) => {
      if (pt.mode === "start") {
        if (currentStroke.length) drawStroke(currentStroke);
        currentStroke = [pt];
      } else {
        currentStroke.push(pt);
      }
    });

    if (currentStroke.length) drawStroke(currentStroke);

    ctx.globalAlpha = 1;
    ctx.globalCompositeOperation = "source-over";
  }, [
    drawingsByPage,
    currentIndex,
    currentStrokeWidth,
    selectedColor,
    opacity,
  ]);

  useEffect(() => {
    setScalePercent(Math.floor(scale * 100));
  }, [scale]);

  // Close the dragging icon when right-clicked
  useEffect(() => {
    document.addEventListener("mouseup", handleMouseUp);
    document.addEventListener("contextmenu", handleRightClick); // Right-click handler
    return () => {
      document.removeEventListener("mouseup", handleMouseUp);
      document.removeEventListener("contextmenu", handleRightClick);
    };
  }, []);

  const handleIconDoubleClick = (icon) => {
    const index = iconsStore.findIndex((index) => index === icon);
    setSelectedIcon(index);
  };

  const handleIconSingleClick = (icon) => {
    const index = iconsStore.findIndex((index) => index === icon);
    console.log(index);
    setSelectedIcon(index);
  };
  // Update cursor position
  const handleBaseMouseMove = throttle((event) => {
    setMouseBasePos({ x: event.clientX, y: event.clientY });
  }, 4); // Update every ~16ms (60FPS)

  useEffect(() => {
    const container = containerRef.current;

    if (container) {
      container.addEventListener("mousemove", handleBaseMouseMove);
      return () =>
        container.removeEventListener("mousemove", handleBaseMouseMove); // Cleanup
    }
  }, []);

  const getImageCoords = (clientX, clientY) => {
    const rect = canvasRef.current.getBoundingClientRect();

    // Mouse position inside the scaled + rotated stage
    let x = (clientX - rect.left) / scale;
    let y = (clientY - rect.top) / scale;

    const w = dimensions.width;
    const h = dimensions.height;

    switch (rotation % 360) {
      case 90:
        return { x: y, y: w - x };
      case 180:
        return { x: w - x, y: h - y };
      case 270:
        return { x: h - y, y: x };
      default:
        return { x, y };
    }
  };

  // Save the canvas state as a base64 string
  const saveCanvasState = () => {
    const canvas = canvasRef.current;

    // Get the canvas image as PNG data URL
    const dataURL = canvas.toDataURL("image/png");

    // Optionally, store the canvas state
    // setCanvasStates((prevStates) => ({
    //   ...prevStates,
    //   [currentImage]: dataURL, // Save the canvas state for the current image
    // }));
  };

  const handleDeleteIcon = async (index, icon) => {
    try {
      dispatch(deleteAnnotation(icon));

      if (typeof icon.mark === "number" && icon.questionDefinitionId) {
        const markPayload = {
          questionDefinitionId: icon.questionDefinitionId,
          answerPdfId: currentAnswerPdfId,
          page: icon.page,
          taskId: props.id,
          userId: props.taskdetails?.userId,
        };

        dispatch(deleteMark(markPayload));
        socket.emit("delete-mark", markPayload);

        // setMarkPlaced(false);// ✅ ADD THIS
      }

      setSelectedIcon(null);
      dispatch(setRerender());
    } catch (err) {
      console.error("Delete icon error", err);
    }
  };

  // Zoom in and out with smooth transition
  // const zoomIn = () => setScale((prevScale) => prevScale + 0.1);
  // const zoomOut = () => setScale((prevScale) => prevScale - 0.1);
  // Start drawing when the mouse is pressed down

  const updateZoom = (newScale) => {
    const container = containerRef.current;

    if (!container) {
      setScale(newScale);
      return;
    }

    const prevScale = scale;

    // Current viewport center
    const centerX = container.scrollLeft + container.clientWidth / 2;

    const centerY = container.scrollTop + container.clientHeight / 2;

    // Convert to image coordinates
    const imageX = centerX / prevScale;
    const imageY = centerY / prevScale;

    setScale(newScale);

    requestAnimationFrame(() => {
      // New scroll so same point remains centered
      container.scrollLeft = imageX * newScale - container.clientWidth / 2;

      container.scrollTop = imageY * newScale - container.clientHeight / 2;
    });
  };

  const zoomIn = () => {
    updateZoom(Math.min(scale + 0.1, 1.4));
  };

  const zoomOut = () => {
    updateZoom(Math.max(scale - 0.1, 0.5));
  };

  const handleCanvasMouseDown = (e) => {
    if (!isDrawing || currentIcon) return;

    setStartDrawing(true);

    // const rect = canvasRef.current.getBoundingClientRect();
    // const x = (e.clientX - rect.left) / scale;
    // const y = (e.clientY - rect.top) / scale;

    const { x, y } = getImageCoords(e.clientX, e.clientY);

    setDrawingsByPage((prev) => ({
      ...prev,
      [currentIndex]: [
        ...(prev[currentIndex] || []),
        {
          x,
          y,
          mode: "start", // ⭐ IMPORTANT
          color: selectedColor,
          strokeWidth: currentStrokeWidth,
          tool: toolMode,
        },
      ],
    }));
  };

  // const handleResizeStart = (index, e) => {
  //   e.preventDefault();
  //   e.stopPropagation();

  //   const initialX = e.clientX;
  //   const initialY = e.clientY;
  //   const initialWidth = +icons[index].width;
  //   const initialHeight = +icons[index].height;

  //   const handleMouseMove = (moveEvent) => {
  //     const deltaX = moveEvent.clientX - initialX;
  //     const deltaY = moveEvent.clientY - initialY;

  //     setIcons((prevIcons) =>
  //       prevIcons.map((icon, i) =>
  //         i === index
  //           ? {
  //               ...icon,
  //               width: Math.max(20, initialWidth + deltaX), // Minimum size constraint
  //               height: Math.max(20, initialHeight + deltaY),
  //             }
  //           : icon
  //       )
  //     );
  //   };

  //   const handleMouseUp = () => {
  //     document.removeEventListener("mousemove", handleMouseMove);
  //     document.removeEventListener("mouseup", handleMouseUp);
  //   };

  //   document.addEventListener("mousemove", handleMouseMove);
  //   document.addEventListener("mouseup", handleMouseUp);
  // };

  // Stop drawing when the mouse is released
  const handleCanvasMouseUp = () => {
    setStartDrawing(false);
    setMouseUp(true);
    // setIsDrawing(false);
  };

  // Track mouse movement for dragging icons
  const handleMouseMove = (e) => {
    if (!containerRef.current) return;

    const containerRect = containerRef.current.getBoundingClientRect();

    // 🟢 ICON DRAGGING (existing placed icon)
    if (isDraggingIcon && draggedIconIndex !== null) {
      const { x, y } = getNormalizedCoords(
        e.clientX,
        e.clientY,
        canvasRef,
        scale
      );

      dispatch(
        updateAnnotation({
          x,
          y,
        })
      );

      return;
    }

    // 🟢 ICON PREVIEW FOLLOWING CURSOR
    if (isDraggingIcon && currentIcon) {
      setMousePos({
        x: e.clientX - containerRect.left,
        y: e.clientY - containerRect.top,
      });
      return;
    }

    // 🟢 DRAWING MODE
    if (isDrawing && startDrawing && canvasRef.current) {
      const rect = canvasRef.current.getBoundingClientRect();

      // 🔥 Convert screen coords → canvas coords (fixes zoom offset bug)
      const { x, y } = getNormalizedCoords(
        e.clientX,
        e.clientY,
        canvasRef,
        scale
      );

      setDrawingsByPage((prev) => ({
        ...prev,
        [currentIndex]: [
          ...(prev[currentIndex] || []),
          {
            x,
            y,
            mode: "draw",
            color: selectedColor,
            strokeWidth: currentStrokeWidth,
            tool: toolMode,
          },
        ],
      }));
    }
  };

  // Handle icon selection
  const handleIconClick = (icon) => {
    setIsDraggingIcon(true); // Enable dragging mode
    dispatch(setCurrentIcon(icon));
    // setCurrentIcon(iconUrl); // Set the selected icon
    setIconModal(false); // Close the icon modal
  };

  // Handle dropping the icon on the image
  const handleImageClick = async (e) => {
    console.log("HANDLE IMAGE CLICK WORKING");
    if (!containerRef.current || (!currentIcon && !currentMarkDetails)) return;

    const containerRect = e.currentTarget.getBoundingClientRect();

    const iconType = currentIcon?.type;
    const iconUrl = currentIcon?.imgUrl || currentIcon; // fallback for old flow

    const currentTimeStamp = new Date().toLocaleString();

    const currentUUID = uuidv4();
    console.log("Generated UUID:", currentUUID);
    console.log("UUID Type:", typeof currentUUID);

    const { x, y } = getNormalizedCoords(
      e.clientX,
      e.clientY,
      canvasRef,
      scale
    );

    const isBlank = iconUrl === "/blank.png";

    const blankExists = iconsStore.some(
      (icon) => icon.page === currentIndex && icon.iconUrl === "/blank.png"
    );

    // 🔁 force refresh
    setTimeout(() => {
      dispatch(setRerender());
    }, 500);

    // 🚫 BLOCK if blank exists
    if (!isBlank && blankExists) {
      toast.error(
        "This page is already marked as blank. Remove blank to continue."
      );
      return;
    }

    // ✅ RULE 1: ✔ CHECKER (FULL MARKS ONLY)
    if (iconType === "positive") {
      if (currentMarkDetails?.allottedMarks !== currentMarkDetails?.maxMarks) {
        toast.error("✔ Allowed only for full marks");
        return;
      }
    }

    // ✅ RULE 2: //// SLANT FULL PAGE
    if (iconType === "slant") {
      const slantAnnotation = {
        answerPdfImageId: currentAnswerImageId,
        questionDefinitionId: currentQuestionDefinitionId,
        iconUrl,
        type: "slant",
        page: currentIndex,
        x: 0,
        y: 0,
        width: stageWidth,
        height: stageHeight,
        id: currentUUID,
        timeStamps: currentUUID,
        taskId: props.id,
        answerPdfId: currentAnswerPdfId,
        userId: props.taskdetails?.userId,
        parentQuestionId: currentParentId,
        email: props.userDetails.email,
        role: props.userDetails.role,
      };
      console.log("Slant Annotation UUID:", slantAnnotation.id);
      console.log("Slant Full Object:", slantAnnotation);

      dispatch(addAnnotation(slantAnnotation));

      // 👉 AUTO NEXT PAGE
      dispatch({
        type: "evaluator/setCurrentIndex",
        payload: currentIndex + 1,
      });

      dispatch(setCurrentIcon(null));
      setIsDraggingIcon(false);
      return;
    }

    // ✅ BASE ICON OBJECT
    const iconBody = {
      answerPdfImageId: currentAnswerImageId,
      questionDefinitionId:
        currentQuestionDefinitionId || currentMarkDetails?.questionDefinitionId,
      iconUrl,
      type: iconType,
      question: currentQuestionNo,
      timeStamps: currentUUID,
      page: currentIndex,
      x,
      y,
      width: 150,
      height: 80,
      taskId: props.id,
      answerPdfId: currentAnswerPdfId,
      id: currentUUID,
      userId: props.taskdetails?.userId,
      parentQuestionId: currentParentId,
      email: props.userDetails.email,
      role: props.userDetails.role,
    };

    console.log("Icon Body UUID:", iconBody.id);
    console.log("Icon Body Object:", iconBody);

    // ✅ RULE 3: QUESTION REMARK
    if (iconType === "question") {
      iconBody.label = `Q${currentQuestionNo}`;
      dispatch(addAnnotation(iconBody));
    }

    // ✅ RULE 4: NORMAL MARKING ICONS (✔ ❌ ⭕ 📏 etc.)
    // else if (iconUrl !== "/blank.png" && iconUrl !== "/not_attempt.png") {
    //   const totalMarksBody = {
    //     ...currentMarkDetails,
    //     id: currentTimeStamp,
    //     taskId: props.id,
    //     page: currentIndex,
    //     question: currentQuestionNo,
    //     userId: props.taskdetails?.userId,
    //     parentQuestionId: currentParentId,
    //   };

    //   socket.emit("add-marks", totalMarksBody);
    //   dispatch(addMark(totalMarksBody));
    //   dispatch(
    //     addAnnotation({
    //       ...iconBody,
    //       mark: currentMarkDetails?.allottedMarks,
    //     })
    //   );
    // }
    else if (iconUrl !== "/blank.png" && iconUrl !== "/not_attempt.png") {
      // 👉 CASE 1: MARK MODE ACTIVE
      if (currentMarkDetails?.allottedMarks !== undefined) {
        // 🔥 FIX 1 — prevent click without selecting mark
        const marks = currentMarkDetails?.allottedMarks;

        if (marks === undefined || marks === null) {
          toast.error("Select marks first");
          return;
        }

        // 🔥 FIX 2 — BLOCK repeated click (IMPORTANT)
        // if (markPlaced) {
        //   toast.warning("Mark already placed. Please select again.");
        //   return;
        // }

        // 🔥 FIX 3 — calculate existing marks
        const existingMarks = marksStore.filter(
          (m) =>
            m.questionDefinitionId ===
              currentMarkDetails?.questionDefinitionId &&
            m.page === currentIndex &&
            m.answerPdfId === currentAnswerPdfId
        );

        const totalAssigned = existingMarks.reduce(
          (sum, m) => sum + (m.allottedMarks || 0),
          0
        );

        // 🔥 FIX 4 — HARD STOP (no marks left)
        if (totalAssigned >= currentMarkDetails?.maxMarks) {
          toast.error("No marks remaining for this question");
          return;
        }

        // const markToAdd = currentMarkDetails?.allottedMarks || 0;
        const markToAdd = currentMarkDetails?.allottedMarks;
        const newTotal = totalAssigned + (markToAdd ?? 0);

        // 🔥 FIX 5 — strict overflow check
        if (newTotal > currentMarkDetails?.maxMarks) {
          toast.error("Marks exceed maximum allowed limit");
          return;
        }

        // ✅ FINAL PAYLOAD
        const totalMarksBody = {
          ...currentMarkDetails,
          id: currentTimeStamp,
          taskId: props.id,
          page: currentIndex,
          question: currentQuestionNo,
          userId: props.taskdetails?.userId,
          parentQuestionId: currentParentId,
        };

        // ✅ SEND + STORE
        socket.emit("add-marks", totalMarksBody);
        dispatch(addMark(totalMarksBody));

        // ✅ ADD VISUAL MARK (NO ICON)
        dispatch(
          addAnnotation({
            ...iconBody,
            iconUrl: null,
            mark: markToAdd,
          })
        );

        // 🔥 FIX 6 — LOCK (prevents repeated clicks)
        // setMarkPlaced(true);

        // 🔥 FIX 7 — RESET Redux state
        dispatch(setCurrentMarkDetails(null));

        return;
      }

      // 👉 CASE 2: ONLY ANNOTATION
      dispatch(addAnnotation(iconBody));
    }

    // ✅ RULE 5: BLANK / NOT ATTEMPT
    else {
      dispatch(addAnnotation(iconBody));
    }

    // 🔁 RESET STATE
    dispatch(setCurrentIcon(null));
    dispatch(setRerender());
    setIsDraggingIcon(false);
  };

  // Start dragging an existing icon
  const handleIconDragStart = (index, e) => {
    setDraggedIconIndex(index);
    setIsDraggingIcon(true);
    e.preventDefault(); // Prevent default to avoid text selection
  };

  // Stop dragging an icon
  const handleMouseUp = () => {
    setIsDraggingIcon(false);
    setDraggedIconIndex(null);
  };

  // Handle right-click to stop dragging and hide icon
  const handleRightClick = (e) => {
    e.preventDefault(); // Prevent default context menu
    setIsDraggingIcon(false);
    setDraggedIconIndex(null);
  };
  const iconsByRole = getIconsByRole(role);

  const IconModal = Object.entries(iconsByRole).flatMap(([key, arr]) =>
    arr.map((imgUrl, index) => (
      <img
        key={`${key}-${index}`}
        onClick={() => handleIconClick({ imgUrl, type: key })} // ✅ now key exists
        src={imgUrl}
        width={100}
        height={100}
        className="md h-[60px] w-full cursor-pointer rounded p-2 shadow hover:bg-white"
        alt="icon"
      />
    ))
  );

  const handleZoomValueClick = (zoomValue) => {
    const newScale = zoomValue / 100; // convert % → scale
    setScale(newScale);
    setIsZoomMenuOpen(false); // close dropdown after select
  };

  const ZoomModal = Array.from({ length: 12 }, (_, index) => {
    const zoomValue = 40 + index * 10;
    return (
      <li
        key={index}
        onClick={() => handleZoomValueClick(zoomValue)}
        className="hover:bg-gray-300 "
      >
        {zoomValue}%
      </li>
    );
  });
  const handleZoomMenu = () => {
    setIsZoomMenuOpen(!isZoomMenuOpen);
  };

  const handleDownload = async () => {
    if (!containerRef.current) return null;

    try {
      const imgElement = containerRef.current.querySelector("img");
      const rect = imgElement.getBoundingClientRect();
      // Temporarily adjust styles for capturing full content
      const container = containerRef.current;
      const originalStyle = container.style.cssText;

      // Expand the container to its full scrollable height and width
      // container.style.overflow = "visible";
      container.style.height = `${container.scrollHeight}px`;
      container.style.width = `${container.scrollWidth}px`;

      // Capture the entire container with html2canvas
      const canvas = await html2canvas(container, {
        useCORS: true, // For cross-origin images
        scale: 2, // Increase resolution for better quality
        x: rect.left - containerRef.current.getBoundingClientRect().left, // X offset relative to container
        y: rect.top - containerRef.current.getBoundingClientRect().top, // Y offset relative to container
        width: rect.width, // Width of the image
        height: rect.height, // Height of the image
      });

      // Revert the container's style after capture
      container.style.cssText = originalStyle;

      // // Get the dimensions of the image
      // const imgElement = containerRef.current.querySelector("img");
      // const rect = imgElement.getBoundingClientRect();

      // // Capture the div using html2canvas
      // const canvas = await html2canvas(containerRef.current, {
      //   useCORS: true, // For cross-origin images
      //   scale: 2, // Increase resolution
      //   // x: rect.left - containerRef.current.getBoundingClientRect().left, // X offset relative to container
      //   // y: rect.top - containerRef.current.getBoundingClientRect().top, // Y offset relative to container
      //   // width: rect.width, // Width of the image
      //   // height: rect.height, // Height of the image
      // });

      // Convert the canvas to a Blob (binary data)
      const dataUrl = canvas.toDataURL("image/png");

      //  // Trigger the download
      //  const link = document.createElement("a");
      //  link.href = dataUrl;
      //  link.download = "scaled_image_with_icons.png";
      //  link.click();
      //  return
      const response = await fetch(dataUrl);
      const blob = await response.blob();
      const obj = props.ImageObj;

      if (blob && obj) {
        const formData = new FormData();
        formData.append("image", blob, "captured_image.png");
        formData.append("imageName", obj.imageName);
        formData.append("bookletName", obj.bookletName);
        formData.append("subjectcode", obj.subjectCode);

        await submitImageById(formData);
      } else {
        console.error("Failed to capture the image");
      }
    } catch (error) {
      console.error("Failed to capture and download cropped image:", error);
      return null;
    }
  };

  // const mergedIcons = iconsStore.map((icon) => {
  //   const markData = marksStore.find(
  //     (m) =>
  //       m.questionDefinitionId === icon.questionDefinitionId &&
  //       m.page === icon.page &&
  //       m.answerPdfId === icon.answerPdfId
  //   );

  //   return {
  //     ...icon,
  //     mark: icon.mark ?? markData?.allottedMarks ?? 0,
  //   };
  // });
  // console.log(commentStore);
  // console.log(iconsStore);
  // console.log(marksStore);

  const isSideways = rotation % 180 !== 0;

  const stageWidth =
    (isSideways ? dimensions.height : dimensions.width) * scale;
  const stageHeight =
    (isSideways ? dimensions.width : dimensions.height) * scale;

  return (
    <>
      <div style={{ height: "7%" }}>
        <Tools
          scalePercent={scalePercent}
          handleZoomMenu={handleZoomMenu}
          isZoomMenuOpen={isZoomMenuOpen}
          ZoomModal={ZoomModal}
          zoomIn={zoomIn}
          zoomOut={zoomOut}
          setShowLens={setShowLens}
          isDrawing={isDrawing}
          lensSize={lensSize}
          setLensSize={setLensSize}
          setIsDrawing={setIsDrawing}
          iconModal={iconModal}
          setIconModal={setIconModal}
          currentIcon={currentIcon}
          IconModal={IconModal}
          setSelectedColor={setSelectedColor}
          setCurrentStrokeWidth={setCurrentStrokeWidth}
          setToolMode={setToolMode}
          setOpacity={setOpacity}
          toolMode={toolMode}
          comments={comments}
          setRotation={setRotation}
          setcomments={setcomments}
          taskId={props.id}
          setAiResult={props.setAiResult}
        />
      </div>
      {/* Image Viewer Section */}
      <button
        onClick={handleDownload}
        id="download-png"
        style={{ display: "none" }}
      >
        Download Image
      </button>
      <div
        ref={containerRef}
        style={{
          marginTop: "20px",
          borderLeft: "1px solid #ccc",
          borderRight: "1px solid #ccc",
          overflowY: "auto",
          overflowX: "auto",
          position: "relative",
          width: "100%",
          height: `92%`,
          cursor: isDrawing ? "url('/toolImg/Handwriting.cur'), auto" : "",
        }}
      >
        {/* ZOOM VIEWPORT (centers content but does NOT scale interaction layer) */}
        <div
          style={{
            position: "relative",
            width: "100%",
            minHeight: "100%",
            display: "flex",
            // justifyContent:
            //   stageWidth < (containerRef.current?.clientWidth || 0)
            //     ? "center"
            //     : "flex-start",
            // alignItems:
            //   stageHeight < (containerRef.current?.clientHeight || 0)
            //     ? "center"
            //     : "flex-start",
            justifyContent: "center",
            alignItems: "center",
          }}
          onMouseEnter={() => setIsCursorInside(true)}
          onMouseLeave={() => setIsCursorInside(false)}
        >
          {/* FIXED SIZE STAGE (real coordinates live here) */}
          <div
            style={{
              position: "relative",
              width: stageWidth,
              height: stageHeight,
            }}
          >
            {/* 🔹 VISUAL LAYER (SCALED) */}
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                width: dimensions.width * scale,
                height: dimensions.height * scale,
                transform: `translate(-50%, -50%) rotate(${rotation}deg)`,
                transformOrigin: "center center",
              }}
            >
              <img
                ref={imgRef}
                src={imageSrc}
                alt="Viewer"
                className="block"
                crossOrigin="anonymous"
                onLoad={() => setImageLoaded(true)}
                style={{ pointerEvents: "none", width: "100%", height: "100%" }}
              />

              {/* <canvas
                ref={canvasRef}
                width={canvasSize.width}
                height={canvasSize.height}
                className={`absolute left-0 top-0 z-10 pointer-events-${
                  isDrawing ? "auto" : "none"
                }`}
              /> */}
              <canvas
                ref={canvasRef}
                width={dimensions.width}
                height={dimensions.height}
                className={`absolute left-0 top-0 z-10 ${
                  isDrawing && !currentIcon
                    ? "pointer-events-auto"
                    : "pointer-events-none"
                }`}
              />
            </div>

            {/* 🔹 INTERACTION LAYER (NOT SCALED) */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
              onDoubleClick={comments ? handleAddComments : null}
              onClick={handleImageClick}
              onMouseMove={(e) => {
                handleMouseMove(e);

                if (showLens) {
                  const rect = e.currentTarget.getBoundingClientRect();

                  // Lens position on screen
                  setLensPos({
                    x: e.clientX - rect.left,
                    y: e.clientY - rect.top,
                  });

                  // REAL image coordinates
                  const imageCoords = getImageCoords(e.clientX, e.clientY);

                  setLensImagePos(imageCoords);
                }
              }}
              onMouseDown={handleCanvasMouseDown}
              onMouseUp={handleCanvasMouseUp}
            >
              {/* COMMENTS */}
              {imageLoaded &&
                commentStore
                  .filter((a) => a.taskId === props.id)
                  .filter((a) => a.page === currentIndex)
                  .map((a) => (
                    <Rnd
                      key={a.id}
                      position={{
                        x: a.x * scale,
                        y: a.y * scale,
                      }}
                      size={{
                        width: a.width * scale,
                        height: a.height * scale,
                      }}
                      bounds="parent"
                      style={{
                        pointerEvents: isDrawing ? "none" : "auto",
                      }}
                      onDragStop={(e, d) =>
                        handleDragStop(a.id, d.x / scale, d.y / scale)
                      }
                      onResizeStop={(e, direction, ref, delta, position) => {
                        dispatch(
                          updateComment({
                            ...a,
                            width: ref.offsetWidth,
                            height: ref.offsetHeight,
                            x: position.x / scale,
                            y: position.y / scale,
                            synced: false,
                          })
                        );
                      }}
                    >
                      <div className="group relative h-full w-full">
                        <button
                          onMouseDown={(e) => e.stopPropagation()}
                          onClick={(e) => {
                            e.stopPropagation();
                            dispatch(deleteComment(a));
                          }}
                          className="absolute -right-3 -top-3 z-10 flex h-6 w-6 items-center justify-center rounded-full border-2 border-white bg-red-500 text-white opacity-100 shadow-lg transition-all hover:scale-110 hover:bg-red-600 group-hover:opacity-100"
                        >
                          ✖
                        </button>

                        <div className="h-full w-full overflow-hidden rounded-md border border-gray-300 bg-white shadow-sm">
                          <textarea
                            className="comment-box bg-transparent h-full w-full resize-none border-none p-3 text-sm outline-none"
                            value={a.text}
                            onChange={(e) => handleCommentChange(a.id, e)}
                            placeholder="Write comment..."
                          />
                        </div>
                      </div>
                    </Rnd>
                  ))}

              {/* ICONS */}
              {imageLoaded &&
                iconsStore
                  .filter((a) => a.page === currentIndex)
                  .map((icon) => {
                    const isCheck =
                      typeof icon.mark === "number" && icon.mark > 0;
                    const checkClass = isCheck
                      ? "text-green-600 ring-2 ring-green-600"
                      : "text-red-600 ring-2 ring-red-600";
                    const blankClass =
                      icon.iconUrl === "/blank.png" ? "none" : "";

                    return (
                      <Rnd
                        key={icon.timeStamps}
                        size={{
                          width: icon.width * scale,
                          height: icon.height * scale,
                        }}
                        position={{
                          x: icon.x * scale,
                          y: icon.y * scale,
                        }}
                        bounds="parent"
                        style={{
                          pointerEvents: isDrawing ? "none" : "auto",
                        }}
                        onDragStop={(e, d) => {
                          dispatch(
                            updateAnnotation({
                              ...icon,
                              x: d.x / scale,
                              y: d.y / scale,
                            })
                          );
                        }}
                        onResizeStop={(e, direction, ref) =>
                          dispatch(
                            updateAnnotation({
                              ...icon,
                              width: ref.offsetWidth / scale,
                              height: ref.offsetHeight / scale,
                            })
                          )
                        }
                        onClick={() => handleIconSingleClick(icon)}
                        onDoubleClick={() => handleIconDoubleClick(icon)}
                        className="absolute z-10 rounded-lg p-2"
                      >
                        <div className="relative h-full w-full">
                          {selectedIcon ===
                            iconsStore.findIndex((i) => i === icon) && (
                            <button
                              onMouseDown={(e) => e.stopPropagation()}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteIcon(null, icon);
                              }}
                              className="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-white shadow hover:bg-red-600"
                            >
                              ✖
                            </button>
                          )}

                          {/* <img
                            src={icon.iconUrl}
                            alt="icon"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                            }}
                          />

                          <div
                            className="mt-2 text-center text-xl font-semibold text-gray-700"
                            style={{ display: blankClass }}
                          >
                            <span className="mr-1">{`Q${icon.question}`}</span>→
                            <span
                              className={`ml-1 inline-flex min-w-[1.5rem] items-center justify-center rounded-full bg-gray-50 p-1 font-extrabold ${checkClass}`}
                            >
                              {icon?.mark ?? 0}
                            </span>
                          </div> */}

                          {/* {typeof icon.mark === "number" && icon.mark > 0 ? (
                            // ✅ SHOW ONLY MARK
                            <div className="mt-2 text-center text-xl font-semibold text-gray-700">
                              <span className="mr-1">{`Q${icon.question}`}</span>
                              →
                              <span
                                className={`ml-1 inline-flex min-w-[1.5rem] items-center justify-center rounded-full bg-gray-50 p-1 font-extrabold ${checkClass}`}
                              >
                                {icon.mark}
                              </span>
                            </div>
                          ) : (
                            // ✅ SHOW ONLY ANNOTATION ICON
                            <img
                              src={icon.iconUrl}
                              alt="icon"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                              }}
                            />
                          )} */}

                          {icon.iconUrl === null ? (
                            // ✅ SHOW MARK (iconUrl is null = mark mode)
                            <div className="mt-2 text-center text-xl font-semibold text-gray-700">
                              <span className="mr-1">{`Q${icon.question}`}</span>
                              →
                              <span
                                className={`ml-1 inline-flex min-w-[1.5rem] items-center justify-center rounded-full bg-gray-50 p-1 font-extrabold ${checkClass}`}
                              >
                                {icon.mark}
                              </span>
                            </div>
                          ) : (
                            // ✅ SHOW ANNOTATION ICON
                            <img
                              src={icon.iconUrl}
                              alt="icon"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                              }}
                            />
                          )}

                          {/* <div className="text-md mt-1 text-center font-extrabold italic text-gray-700 opacity-75">
                            {icon.timeStamps}
                          </div> */}
                        </div>
                      </Rnd>
                    );
                  })}
            </div>

            {/* 🔍 MAGNIFIER LENS */}
            {showLens && (
              <div
                style={{
                  position: "absolute",
                  left: lensPos.x - lensSize / 2,
                  top: lensPos.y - lensSize / 2,
                  width: lensSize,
                  height: lensSize,
                  borderRadius: "50%",
                  border: "2px solid #333",
                  overflow: "hidden",
                  pointerEvents: "none",
                  zIndex: 2000,
                  backgroundImage: `url(${lensImage || imageSrc})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: `${dimensions.width * scale * lensZoom}px ${
                    dimensions.height * scale * lensZoom
                  }px`,

                  backgroundPosition: `
  -${lensImagePos.x * scale * lensZoom - lensSize / 2}px
  -${lensImagePos.y * scale * lensZoom - lensSize / 2}px
`,
                  transform: `rotate(${rotation}deg)`,
                }}
              />
            )}
          </div>
        </div>

        {/* Icon following the mouse while dragging */}
        {isDraggingIcon && currentIcon && (
          <div
            style={{
              position: "absolute",
              top: `${mousePos.y}px`, // Adjust for scaling
              left: `${mousePos.x}px`, // Adjust for scaling
              zIndex: 1000,
              pointerEvents: "none",
              // transform: `scale(${scale})`, // Scale the preview
              transition: "transform 0.2s ease-in-out", // Smooth transition
            }}
          >
            <img src={currentIcon} alt="dragging-icon" width={40} height={40} />
          </div>
        )}

        {/* Display current question number at cursor */}
        {isCursorInside && (
          <div
            className={`z-1000 pointer-events-none fixed rounded bg-gray-100 p-2.5 text-sm shadow-md`}
            style={{
              left: `${mouseBasePos.x}px`,
              top: `${mouseBasePos.y + 5}px`, // Dynamic positioning
            }}
          >
            {`Q(${currentQuestionNo})`}
          </div>
        )}
      </div>
    </>
  );
};

export default React.memo(ImageContainer);
